const addSubmitHandler = (formElement: HTMLFormElement) => {
  formElement.addEventListener('submit', (event) => {
    event.preventDefault();
    const formData = new FormData(formElement);
    const path = formData.get('coveragetype') as string;
    location.assign(path);
  });
};

export const initialize = (selector = '[data-url-select]') => {
  document.querySelectorAll(selector).forEach((element) => {
    addSubmitHandler(element as HTMLFormElement);
  });
};
